export const IDLE = 'idle';
export const MOVING = 'moving';
export const REMOVING = 'removing';
